import { InMemoryHeader, InMemoryString, InMemoryDate, InMemoryDecimal } from "pbas-vue-components";
import { translate2 } from "../trans2";
import { formatBytes } from "../utils/file"
import { i18n } from '@/plugins/i18n';

const MemberFilesHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  // new InMemoryHeader({
  //   title: "globals.employer",
  //   type: new InMemoryString(
  //     "MemberIdentity/CurrentEmploymentInformation/Employer/Translations[]/Name",
  //     {
  //       getString: (item) => {
  //         if (
  //           !item ||
  //           !item.MemberIdentity ||
  //           !item.MemberIdentity.CurrentEmploymentInformation ||
  //           !item.MemberIdentity.CurrentEmploymentInformation.Employer ||
  //           !item.MemberIdentity.CurrentEmploymentInformation.Employer.Name ||
  //           item.MemberIdentity.CurrentEmploymentInformation.Employer.Name ===
  //             ""
  //         )
  //           return "";
  //         return translate2(
  //           item.MemberIdentity.CurrentEmploymentInformation.Employer,
  //           "Name"
  //         );
  //       },
  //     }
  //   ),
  // }),
  // new InMemoryHeader({
  //   title: "filebrowser.filedetails.owner",
  //   type: new InMemoryString("MemberIdentity/CurrentMember/FirstName", {
  //     getString: (item) => {
  //       if (!item || !item.MemberIdentity) {
  //         return "";
  //       }
  //       let res = [];
  //       if (
  //         item.MemberIdentity.CurrentMember &&
  //         item.MemberIdentity.CurrentMember.FirstName &&
  //         item.MemberIdentity.CurrentMember.FirstName !== ""
  //       ) {
  //         res.push(item.MemberIdentity.CurrentMember.FirstName);
  //       }

  //       if (
  //         item.MemberIdentity.CurrentMember &&
  //         item.MemberIdentity.CurrentMember.LastName &&
  //         item.MemberIdentity.CurrentMember.LastName !== ""
  //       ) {
  //         res.push(item.MemberIdentity.CurrentMember.LastName);
  //       }
  //       if (
  //         item.MemberIdentity.MemberIdentification &&
  //         item.MemberIdentity.MemberIdentification.Certificate
  //       ) {
  //         res.push(item.MemberIdentity.MemberIdentification.Certificate);
  //       }

  //       return res.join(" ");
  //     },
  //     getHtml: (item, type) => {
  //       return (
  //         "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
  //         type.getString(item, type) +
  //         "</div>"
  //       );
  //     }
  //   }),
  // }),
  new InMemoryHeader({
    title: "globals.category",
    type: new InMemoryString("FileCategory", {
      getString: (item) => {
        return i18n.t("enums." + item.FileCategory);
      },
    }),
  }),
  new InMemoryHeader({
    title: "headers.employer_files.code",
    type: new InMemoryString("Code"),
  }),
  new InMemoryHeader({
    title: "globals.effective_date",
    type: new InMemoryDate("EffectiveDate"),
  }),
  new InMemoryHeader({
    title: "headers.employer_files.expiry_date",
    type: new InMemoryDate("ExpiryDate"),
  }),
  new InMemoryHeader({
    title: "components.employers.employer_details.notes",
    type: new InMemoryString(
      "Note/Text"
    ),
    visible: true,
    searchable: true,
    sortable: true
  }),
  // new InMemoryHeader({
  //   title: "globals.name",
  //   type: new InMemoryString("FileSegments[]/FileName", {
  //     getString: (item) => {
  //       if (!item || !item.FileSegments) {
  //         return "";
  //       }
  //       return item.FileSegments.filter((x) => x.FileName && x.FileName !== "")
  //         .map((x) => x.FileName)
  //         .join(", ");
  //     },
  //     getHtml: (item, type) => {
  //       return (
  //         "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
  //         type.getString(item, type) +
  //         "</div>"
  //       );
  //     }
  //   }),
  //   allowVisibilityChange: true,
  //   sortable: false,
  //   visible: false,
  //   version: 2
  // }),
  new InMemoryHeader({
    title: "headers.pendinghourstasks.created_by",
    type: new InMemoryString("CreatedBy"),
  }),
  new InMemoryHeader({
    title: "headers.member_files.created_on",
    type: new InMemoryDate("Timestamp"),
  }),
  // new InMemoryHeader({
  //   title: "globals.type",
  //   type: new InMemoryString("FileSegments[]/FileType", {
  //     getString: (item) => {
  //       if (!item || !item.FileSegments) {
  //         return "";
  //       }
  //       return item.FileSegments.filter((x) => x.FileType && x.FileType !== "")
  //         .map((x) => x.FileType)
  //         .join(", ");
  //     },
  //     getHtml: (item, type) => {
  //       return (
  //         "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
  //         type.getString(item, type) +
  //         "</div>"
  //       );
  //     }
  //   }),
  //   sortable: false,
  //   version: 1
  // }),
  // new InMemoryHeader({
  //   title: "headers.member_files.size",
  //   type: new InMemoryDecimal("FileSegments[]/FileSize", {
  //     getString: (item) => {
  //       if (!item || !item.FileSegments) {
  //         return "";
  //       }
  //       return item.FileSegments.map((x) => formatBytes(x.FileSize))
  //         .join(", ");
  //     },
  //     getHtml: (item, type) => {
  //       return (
  //         "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
  //         type.getString(item, type) +
  //         "</div>"
  //       );
  //     }
  //   }),
  //   sortable: false,
  //   version: 1
  // }),
  new InMemoryHeader({
    type: new InMemoryString("FileSegments[]/PhysicalFileId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false
  }),
  // new InMemoryHeader({
  //   type: new InMemoryDate("FileSegments[]/Timestamp"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("MemberIdentity/CurrentMember/LastName"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  //   sortable: false,
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString("MemberIdentity/MemberIdentification/Certificate"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  //   sortable: false,
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString(
  //     "MemberIdentity/CurrentEmploymentInformation/Employer/Translations[]/LanguageCode"
  //   ),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  // new InMemoryHeader({
  //   type: new InMemoryString(
  //     "MemberIdentity/CurrentEmploymentInformation/Store/Translations[]/LanguageCode"
  //   ),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  
];
export default MemberFilesHeaders;
